import { ASSETS } from '@/constants/assets';

export default function FloatingWhatsApp() {
  return (
    <a
      href={ASSETS.social.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com um especialista pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-primary-500 text-background-50 rounded-full flex items-center justify-center shadow-lg hover:bg-primary-600 transition-all duration-300 hover:scale-110 cursor-pointer"
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
    </a>
  );
}